<!-- 管理员操作日志-->
<template>
  <div>
    <x-operLog></x-operLog>
  </div>
</template>

<script>
import { operLog } from 'ant-design-vue-admin-x';
export default {
  name: 'operLog',
  components: {
    XOperLog: operLog
  }
};
</script>
